import React, { useSyncExternalStore } from "react";
import { LANGS, getLang, rawTemplate, setLang, subscribe } from "./core";

export { LANGS, LANG_SWITCH, getLang, setLang, t, tList, textDir } from "./core";
export { trServer, trRoomName } from "./server";

/**
 * Subscribes the component to the active language so it re-renders on switch.
 * `t()` itself is a plain module function (safe in effects and callbacks).
 */
export function useLang() {
  const lang = useSyncExternalStore(subscribe, getLang, getLang);
  const { dir } = LANGS[lang];
  return { lang, dir, isRtl: dir === "rtl", setLang };
}

/**
 * Like t(), but placeholders can be React nodes and `<b>…</b>` is rendered.
 * `vars` only feeds plural functions. The caller sets `dir` on the container.
 */
export function tRich(key, nodes = {}, vars) {
  return rawTemplate(key, vars)
    .split(/(\{\w+\}|<b>.*?<\/b>)/g)
    .filter(Boolean)
    .map((part, i) => {
      const placeholder = /^\{(\w+)\}$/.exec(part);
      if (placeholder) return <React.Fragment key={i}>{nodes[placeholder[1]]}</React.Fragment>;
      const bold = /^<b>(.*)<\/b>$/.exec(part);
      if (bold) return <b key={i}>{bold[1]}</b>;
      return part;
    });
}
